<template>
  <div>
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-8 mb-0 mb-xl-0">
            <h4 class="font-weight-bold">List of USSD Apps</h4>
          </div>
          <div class="col-4">
            <router-link class="btn btn-primary btn-icon-text text-white float-right" to="/create-app">
              <span class="h4 text-white">New App </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <div class="d-flex justify-content-end mb-3">
        <div class="search-box">
          <input 
            type="text" 
            class="form-control" 
            v-model="searchQuery" 
            placeholder="Search apps..."
            @input="filterTable"
          />
          <i class="fa fa-search search-icon"></i>
        </div>
      </div>
      <table id="order-listing1" class="table">
        <thead>
          <tr>
            <th>App Name</th>
            <th>Company Name</th>
            <th>User Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in filteredTableData" :key="data.appId">
            <td>{{ data.appName }}</td>
            <td>{{ data.companyName }}</td>
            <td>{{ data.userEmail }}</td>
            <td>
              <router-link class="btn btn-outline-success ml-2 design" :to="'/app/design/' + data.appId"
                data-toggle="tooltip" title="Open Designer" data-placement="top" data-content="Design your app"
                data-intro="Hello step one!">
                <i class="fa fa-external-link" tooltip="Open Designer"></i>
              </router-link>
              <router-link class="btn btn-outline-primary ml-2 appsettings" :to="'/app-settings/' + data.appId"
                data-toggle="tooltip" title="App Settings">
                <i class="fa fa-cogs"></i>
              </router-link>
              <button @click="cloneAppClicked(data)" class="btn btn-outline-warning ml-2 cloneapp"
                data-bs-toggle="tooltip" data-toggle="tooltip" title="Clone App">
                <i class="fa fa-clone"></i>
              </button>
              <button class="btn btn-outline-danger ml-2 deleteapp" @click="deleteApp(data.appId)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <div class="modal fade" id="duplicateAppModal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel"
          aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="ModalLabel">
                  Clone App : {{ cloneAppData.appName }}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label class="col-form-label">App Name:</label>
                    <input type="text" class="form-control" v-model="cloneAppData.appName" />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Description:</label>
                    <input type="text" class="form-control" v-model="cloneAppData.description" />
                  </div>
                  <div class="form-group ml-4">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="selectDifferentAccount" v-model="cloneAppData.selectDifferentAccount" />
                      <label class="form-check-label" for="selectDifferentAccount">Clone into Different Account</label>
                    </div>
                  </div>
                  <div class="form-group" v-if="cloneAppData.selectDifferentAccount">
                    <label class="col-form-label">Select Account:</label>
                    <multiselect
                      v-model="selectedMerchant"
                      :options="merchants"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Search for an account..."
                      track-by="uuid"
                      label="companyName"
                      @select="onMerchantSelect"
                    >
                      <template v-slot:option="props">
                        <div class="option__desc">
                          <span class="option__title">{{ props.option.companyName }}</span>
                          <span class="option__small">{{ props.option.fullName }}</span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-success text-white" @click="cloneAppSubmitted()" 
                  :disabled="cloneAppData.selectDifferentAccount && !cloneAppData.selectedMerchantUuid">
                  Clone App
                </button>
                <button type="button" class="btn btn-light" @click="closeModal()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import baseUrl from "@/shared/baseUrl";
import api from "@/shared/menuApi";
import { useToast } from "vue-toastification";
import { appTourMixin } from "@/shared/vueTourMixins";
import $ from 'jquery';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import Shepherd from "shepherd.js";
export default {
  name: "CreateApp",
  components: {
    Multiselect
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  name: "my-tour",
  mixins: [appTourMixin],
  data() {
    return {
      createAppData: {
        appName: "",
        description: "",
        useTemplateTag: "",
        shortCode: "",
      },
      cloneAppData: {
        appId: "",
        appName: "",
        description: "",
        useTemplateTag: false,
        selectDifferentAccount: false,
        selectedMerchantUuid: ""
      },
      selectedMerchant: null,
      merchants: [],
      tableData: [],
      filteredTableData: [],
      searchQuery: "",
      errors: {},
    };
  },
  methods: {
    getApp() {
      api
        .getAllApps()
        .then((response) => {
           if(response.error){
            console.log("Going to login")
            this.$router.push("/login");
            return;
          }
          this.tableData = response.data;
          this.filteredTableData = [...this.tableData];
          if (this.tableData.length == 0) {
            this.$router.push("/get-started");
          }
        })
        .catch((error) => {
          console.log("Error", error);
          this.errors = error.data;
        });
    },
    filterTable() {
      if (!this.searchQuery) {
        this.filteredTableData = [...this.tableData];
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredTableData = this.tableData.filter(item => {
        return (
          item.appName.toLowerCase().includes(query) ||
          item.companyName.toLowerCase().includes(query) ||
          item.userEmail.toLowerCase().includes(query)
        );
      });
    },
    closeModal() {
      this.selectedMerchant = null;
      jQuery("#duplicateAppModal").modal("hide");
    },
    async getMerchants() {
      try {
        const response = await api.doGet('/api/merchant/list');
        if (response.status === "00") {
          this.merchants = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch merchants");
        }
      } catch (error) {
        console.error("Error fetching merchants:", error);
        this.toast.error("An error occurred while fetching merchants");
      }
    },
    onMerchantSelect(selectedOption) {
      this.cloneAppData.selectedMerchantUuid = selectedOption.uuid;
    },
    cloneAppClicked(data) {
      this.cloneAppData = {
        appId: data.appId,
        appName: data.appName,
        description: data.description,
        useTemplateTag: data.useTemplateTag,
        selectDifferentAccount: false,
        selectedMerchantUuid: ""
      };
      this.selectedMerchant = null;
      this.getMerchants();
      jQuery("#duplicateAppModal").modal("show");
    },
    cloneAppSubmitted() {
      let payload = {
        appId: this.cloneAppData.appId,
        appName: this.cloneAppData.appName,
        description: this.cloneAppData.description,
        useTemplateTag: this.cloneAppData.useTemplateTag
      };

      if (this.cloneAppData.selectDifferentAccount) {
        payload.merchantUuid = this.cloneAppData.selectedMerchantUuid;
      }

      const vm = this;
      api
        .cloneApp(payload)
        .then((response) => {
          vm.cloneAppData = {
            appId: "",
            appName: "",
            description: "",
            useTemplateTag: false,
            selectDifferentAccount: false,
            selectedMerchantUuid: ""
          };
          if (response.status == "00") {
            this.toast.success(response.message);
          } else {
            this.toast.error(response.message);
          }
          this.getApp();
          jQuery("#duplicateAppModal").modal("hide");
        })
        .catch((error) => {
          this.toast.error(error.message);
        });
    },
    deleteApp(id) {
      //prompt user to confjirm delete
      if (confirm("Are you sure you want to delete this app?")) {
        const token = localStorage.getItem("token");
        baseUrl
          .get("/deleteApp/" + id, {
            headers: { Authorization: token },
          })
          .then((response) => {
            this.getApp();
            console.log;
            this.successMessage = response.data.message;
            this.toast(response.data.message, {
              type: "success",
              position: "top-right",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
            this.toast(error.message, {
              type: "error",
              position: "top-right",
              duration: 3000,
            });
          });
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getApp();
    
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
     
  },
  beforeDestroy() {
    $('.select2').select2('destroy');
  }
};
</script>
<style scoped>
#submitBtn {
  margin-top: 20px;
}

.multiselect {
  margin-bottom: 1rem;
}

.multiselect__tags {
  background-color: #2b2e4c;
  border: 1px solid #424351;
  color: #0b0737;
  min-height: 40px;
  padding: 8px 40px 0 8px;
  border-radius: 4px;
}

.multiselect__select {
  background: #2b2e4c;
  height: 38px;
  width: 38px;
}

.multiselect__select:before {
  border-color: #fff transparent transparent;
  border-width: 5px 5px 0;
  margin-top: -2.5px;
}

.multiselect__input, 
.multiselect__single {
  background-color: #2b2e4c;
  color: #d110ca;
  font-size: 14px;
  padding: 4px 0;
}

.multiselect__input::placeholder {
  color: #6c757d;
}

.multiselect__tag {
  background: #007bff;
  color: #241d4e;
  border-radius: 3px;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 4px 26px 4px 10px;
}

.multiselect__tag-icon {
  border-right: 0;
  padding: 0 5px;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #0056b3;
}

.multiselect__content-wrapper {
  background: #2b2e4c;
  border: 1px solid #424351;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.multiselect__element .multiselect__option {
  color: #1e1039;
  padding: 10px;
  min-height: 40px;
  line-height: 20px;
  font-size: 14px;
}

.multiselect__option--selected .multiselect__option--highlight {
    background: #402f82;
    color: #d11515;
}



.multiselect__option--highlight {
  background: #007bff;
  color: #fff;
}

.multiselect__option--selected {
  background: #0056b3;
  color: #fff;
}

.multiselect__option--highlight:after {
  background: #007bff;
}

.multiselect__option--selected:after {
  background: #0056b3;
}

.multiselect--active {
  z-index: 1000;
}

.multiselect--active .multiselect__tags {
  border-color: #007bff;
}

.option__desc {
  display: flex;
  flex-direction: column;
}

.option__title {
  font-weight: bold;
  color: #153522;
}

.option__small {
  font-size: 0.9em;
  color: #1e3d09;
}

/* Focus and hover states */
.multiselect__input:focus,
.multiselect__input:hover {
  border-color: #007bff;
}

.multiselect__option:hover {
  background: #424351;
}

/* Disabled state */
.multiselect.is-disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* Loading state */
.multiselect.is-loading  {
  background: #2b2e4c url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fff"><path d="M12 2a10 10 0 1 0 10 10h-2a8 8 0 1 1-8-8V2z"/></svg>') no-repeat center;
  background-size: 16px;
}

.search-box {
  position: relative;
  width: 300px;
}

.search-box input {
  padding-right: 35px;
  background-color: #2b2e4c;
  border: 1px solid #424351;
  color: #fff;
  border-radius: 4px;
}

.search-box input:focus {
  background-color: #2b2e4c;
  border-color: #007bff;
  color: #fff;
  box-shadow: none;
}

.search-box input::placeholder {
  color: #6c757d;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}
</style>
